import { FabricEvent } from "../types/FabricCustomType";

export const isTouchInteraction = (event: FabricEvent): boolean => {
  const e = event.e as any;

  return (
    e.pointerType === "touch" ||
    e.pointerType === "pen" ||
    "ontouchstart" in window
  );
}

export const isTouchDevice = (): boolean => {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0
  );
}
